

    /**
     * Returns a new function that will return the value
     */
    function constant(value){
        return function() {
            return value;
        };
    }

    module.exports = constant;





//////////////////
// WEBPACK FOOTER
// ./~/mout/function/constant.js
// module id = 1591
// module chunks = 0 1 2